import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const MONTH_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Month.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .number('code', 'Entity.Month.Code')
    .required()
    .build(),
];

export const MONTH_CONFIG = {
  entityName: 'Month',
  localizationKey: 'General::Entity.Month',
  fields: MONTH_FIELDS,
  permission: 'ControllingCalendar.Months',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Calendar + MENU_NAME_SUFFIX,
};
